import React, { useEffect, useState, useRef } from 'react';
//import moment from 'moment';
import { useApi } from '../../../context/ApiProvider';
import { Link } from 'react-router-dom';
import SearchClients from '../../SearchClients';
import FilterModal from '../../Helpers/Modals/DateFilterModal';
import dayjs from 'dayjs';
import InvoiceModal from '../../Helpers/Modals/InvoiceModal';
import {calculateInvoiceStatistics } from '../invoiceCalculations';

function AllInvoices() {
    const [invoices, setInvoices] = useState(false);
    const [sortOrder, setSortOrder] = useState({name: "", order: "asc"}); // För sortering av invoices efter clientname
    const [loading, setLoading] = useState(true);
    const [searchFilter, setSearchFilter] = useState({searchString: "", fromDate: dayjs().startOf("year"), toDate: dayjs().endOf("year"), partner: ""});
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [clients, setClients] = useState([]);
    const [partners, setPartners] = useState([]);
    const Api = useApi();
    const selectCustomerRef = useRef("");
    const selectPartnersRef = useRef("");
    const [filteredInvoices, setFilteredInvoices] = useState([]);
    const [modalData, setModalData] = useState({visible: false, invoice: null});
    const [statistics, setStatistics] = useState(null); // Statistik för fakturor
    

    useEffect(() => {
        fetchInvoices();
        fetchClients();
    }, []);

    useEffect(() => {
        if (!invoices) return;

        let partners = getPartnersFromInvoices();
        setPartners(partners);

        const statistics = calculateInvoiceStatistics(clients, invoices); // Beräkna statistik för alla fakturor
        setStatistics(statistics);


    }, [invoices]);

    useEffect(() => {
        if (!invoices) return;
    
        const filtered = invoices.filter((invoice) => {
            const invoiceData = JSON.parse(invoice.invoiceData); // Parsar invoiceData
            return (
                (searchFilter.searchString ? invoiceData.customerName.toLowerCase().includes(searchFilter.searchString.toLowerCase()) : true) &&
                (searchFilter.fromDate ? dayjs.unix(invoice.invoiceDate).isAfter(dayjs(searchFilter.fromDate), 'second') : true) &&
                (searchFilter.toDate ? dayjs.unix(invoice.invoiceDate).isBefore(dayjs(searchFilter.toDate), 'second') : true) &&
                (searchFilter.partner ? invoiceData?.partnerName?.toLowerCase().includes(searchFilter.partner.toLowerCase()) : true)
            );
        });
    
        setFilteredInvoices(filtered); // Uppdatera state med de filtrerade fakturorna
    }, [invoices, searchFilter]);

    function fetchInvoices() {
        Api.get("/rolf/invoices").then((result) => {
            setInvoices(result);
            setLoading(false);
        }
        ).catch((err) => {
            console.log(err);
        })
    }

    function fetchClients() {
        //Hämta alla klienter, filtrera ut betalande och aktiva
        Api.get("/rolf/clients").then((data) => {
            let activeClients = data.filter((client) => client.active && client.paying);
            setClients(activeClients);
        }).catch((error) => {

            console.log("Error fetching clients: ", error);
        });
    }

    function updateInvoice(id, field) {
        let invoice = invoices.find(i => i.ID == id); //Hitta rätt faktura
        let invoiceData = JSON.parse(invoice.invoiceData);  //Parsa fakturadatan
        invoiceData[field] = !invoiceData[field]; //Invertera värdet

        if(invoiceData.invoicePaid && !invoiceData.commissionPaid && invoiceData.partnerId) { //Om provision är fakturerad men inte betald och partner finns
            invoiceData.outstandingCommission = invoiceData.commission; //Sätt utestående provision till provisionen
        } else {
            invoiceData.outstandingCommission = 0; //Annars sätt utestående provision till 0
        }

        invoice.invoiceData = JSON.stringify(invoiceData); //Sätt in den nya datan
    
        Api.put(`/rolf/invoices/${id}`, invoice).then(() => { //Uppdatera fakturan
          fetchInvoices(); //Hämta fakturorna igen (refresh)
        }).catch(e => {
          console.log(e);
        })
      }

    function sumOutstandingAmount() {
        return filteredInvoices.reduce((total, invoice) => {
            let parsedData = JSON.parse(invoice.invoiceData);
            return total + parsedData.outstandingCommission;
        }, 0)
    }

    function sumTotalCommission() {
        return filteredInvoices.reduce((total, invoice) => {
            let parsedData = JSON.parse(invoice.invoiceData);
            return total + parsedData.commission;
        }, 0)
    }


    function getPartnersFromInvoices() {
        let partners = [];
        //Vill inte sortera originalarrayen, vill sortera kopian för att namnet på partnern ska vara korrekt ifall det ändrats (= nyast sist), utan att påverka ordningen i tabellen
        let invoicesTemp = [...invoices].sort((a, b) => new Date(a.invoiceDate) - new Date(b.invoiceDate)); 
        invoicesTemp.forEach(invoice => {
            let parsedData = JSON.parse(invoice.invoiceData);
            if (parsedData.partnerId) {
                if (!partners[parsedData.partnerId]) {
                    partners[parsedData.partnerId] = { name: parsedData.partnerName, outstandingCommission: 0 };
                }
                partners[parsedData.partnerId].name = parsedData.partnerName;
                partners[parsedData.partnerId] = { name: parsedData.partnerName, outstandingCommission: partners[parsedData.partnerId].outstandingCommission + parsedData.outstandingCommission };
            }
        });
        return partners.filter(partner => partner !== null && partner !== undefined);
    }

    function toggleSortOrder(columnName) {
        setSortOrder((prevOrder) => {
            if (prevOrder.name === columnName) {
                return { name: columnName, order: prevOrder.order === "asc" ? "desc" : "asc" };
            } else {
                return { name: columnName, order: "asc" };
            }
        });
    }


    if (loading) {
        return <div>Loading...</div>
    }

    function showInvoice(invoice) {
        setModalData({visible: true, invoice: invoice});
    }

    function closeModal() {
        setModalData({visible: false, invoice: null});
    }


    return (<>

        <section className='grow'>
            <div className="flexCenter spaceBetween">
                <h4>Billing overview</h4>
                <div>
                    <select onChange={(e) => {
                        selectPartnersRef.current.value = "";
                        setSearchFilter((prev) => {return {...prev, searchString: e.target.value, partner: ""}})
                    }} ref={selectCustomerRef} style={{marginRight: "1rem"}}>
                        <option value="">All clients</option>
                        {clients && clients.map((client, index) => {
                            return (
                                <option key={index} value={client.name}>{client.name}</option>
                            )
                        })}
                    </select>
                    <select onChange={(e) => {
                        selectCustomerRef.current.value = "";
                        setSearchFilter((prev) => {return {...prev, searchString: "", partner: e.target.value}})
                    }} ref={selectPartnersRef}>
                        <option value="">All partners</option>
                        {partners && partners.map((partner, index) => {
                            return (
                                <option key={index} value={partner.name}>{partner.name}</option>
                            )
                        })}
                    </select>
                </div>

            </div>
            <p>Here you can see all invoices on all clients, and their status. You can also update the "Customer invoice paid", "Commission invoiced" and "Commission paid" fields.</p>
            <a href="#" onClick={() => setShowFilterModal(true)}><i className="fa fa-filter" aria-hidden="true"></i> Date Filter</a> <span className='meta'>{dayjs(searchFilter.fromDate).format("YYYY-MM-DD")} - {dayjs(searchFilter.toDate).format("YYYY-MM-DD")}</span>
            <FilterModal isOpen={showFilterModal} onClose={() => setShowFilterModal(false)} searchFilter={searchFilter} setSearchFilter={setSearchFilter} />

            <SearchClients searchFilter={searchFilter.searchString} setSearchFilter={(string) => {
                selectCustomerRef.current.value = "";
                selectPartnersRef.current.value = "";
                setSearchFilter((prev) => {return {...prev, searchString: string, partner: ""}})
            }} />

            {!invoices ? null :
                <table>
                    <thead>
                        <tr>
                            <th onClick={() => toggleSortOrder("name")}>Customer {sortOrder.name == "name" ? sortOrder.order == "asc" ? "▲" : "▼" : null}</th>
                            <th>Invoice date</th>
                            <th>Value</th>
                            <th>Partner</th>
                            <th>Commission (%)</th>
                            <th>Commission (sek)</th>
                            <th>Customer invoce paid</th>
                            <th>Commission invoiced</th>
                            <th>Commission paid</th>
                            <th>Outstanding commission</th>
                            <th>Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoices.length == 0 ? <tr><td colSpan={12}>No invoices, yet</td></tr> : filteredInvoices.sort((a, b) => {
                                if (sortOrder.name !== "name") return 0; // Om sortOrder inte är på namn, returnera 0 (ingen sortering) 

                                const aName = JSON.parse(a.invoiceData).customerName?.toLowerCase() || "";
                                const bName = JSON.parse(b.invoiceData).customerName?.toLowerCase() || "";
                                if (sortOrder.order === "asc") {
                                    return aName.localeCompare(bName);
                                } else {
                                    return bName.localeCompare(aName);
                                }
                            }).map((invoice, index) => {
                            let invoiceData = JSON.parse(invoice.invoiceData);
                            return (
                                <tr key={index}>
                                    <td><Link to={`/rolf/clients/${invoice.clientId}`}>{invoiceData.customerName}</Link></td>
                                    <td>{dayjs.unix(invoice.invoiceDate).format("YYYY-MM-DD")}</td>
                                    <td>{invoiceData.value}</td>
                                    <td>{invoiceData.partnerName}</td>
                                    <td>{invoiceData.commissionPercentage}</td>
                                    <td>{invoiceData.commission}</td>
                                    <td><input type='checkbox' checked={invoiceData.invoicePaid} onChange={(e) => updateInvoice(invoice.ID, "invoicePaid")}></input></td>
                                    <td><input type='checkbox' checked={invoiceData.commissionInvoiced} disabled={!invoiceData.invoicePaid || !invoiceData.partnerId } onChange={(e) => updateInvoice(invoice.ID, "commissionInvoiced")}></input></td>
                                    <td><input type='checkbox' checked={invoiceData.commissionPaid} disabled={!invoiceData.commissionInvoiced || !invoiceData.invoicePaid || !invoiceData.partnerId } onChange={(e) => updateInvoice(invoice.ID, "commissionPaid")}></input></td>
                                    <td>{invoiceData.outstandingCommission}</td>
                                    <td><a href="#" onClick={() => showInvoice(invoice)}><i className="fa fa-eye" aria-hidden="true"></i></a></td>
                                </tr>
                            )
                        })}
                        <tr>
                            <td colSpan={5}><b>Total:</b></td>
                            <td><b>{Math.round(sumTotalCommission() * 100) / 100}:-</b></td>
                            <td colSpan={3}>&nbsp;</td>
                            <td colSpan={2}><b>{Math.round(sumOutstandingAmount() * 100) / 100}:-</b></td>
                        </tr>
                    </tbody>
                </table>
            }
            <p className='meta'>Invoices are created under Billing overview &gt; Create invoices OR Rolf Administration &gt; Clients &gt; Select client &gt; Add invoice</p>

            <h4>Outstanding commission per partner</h4>
            <p>Here you can see the outstanding commission per partner.</p>
            <table>
                <thead>
                    <tr>
                        <th>Partner Name</th>
                        <th>Outstanding commission</th>
                    </tr>
                </thead>
                <tbody>
                    {partners.map((partner, index) => {
                        return (
                            <tr key={index}>
                                <td>{partner.name}</td>
                                <td>{partner.outstandingCommission.toFixed(2)}:-</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>

            <h4>Statistics</h4>
            {statistics && (
                <>
                <table>
                    <thead>
                        <tr>
                            <th>Month</th>
                            <th>Total Licenses</th>
                            <th>Average Value per License</th>
                            <th>Total Invoiced Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(statistics).map(([month, data], index) => (
                            <tr key={index}>
                                <td>{month}</td>
                                <td><span>{Math.round(Object.values(data.totalLicenses).reduce((a, b) => a + b, 0))}</span><br /><span className='meta'>Reflection: {Math.round(data.totalLicenses.reflection)} | Rolfing: {Math.round(data.totalLicenses.rolfing)} | Development: {Math.round(data.totalLicenses.development)} | Action plan: {Math.round(data.totalLicenses.actionplan)} | Pulse: {Math.round(data.pulseLicenses)}</span></td>
                                <td>{data.avgValuePerLicense.toFixed(2)}:-</td>
                                <td>{Math.round(data.totalValue)}:-</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p className='meta'>The Pulse module is excluded from the statistics and does not affect the total or the avg. value per license, but it affects the total invoiced value.</p>
                </>
            )}
        </section>
        <InvoiceModal modalData={modalData} closeModal={closeModal} onRefresh={fetchInvoices} />
    </>
    )
}

   

export default AllInvoices;